import { cn } from '@/lib/utils'
import { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
interface RewardCardProps {
	heading: ReactNode
	description: string
	image: string
	imageClassName?: string
}

export function RewardCard({ heading, description, image, imageClassName }: RewardCardProps) {
	return (
		<div className='relative flex min-w-0 flex-1 flex-col justify-between gap-6 overflow-hidden rounded-[14px] border border-border bg-secondary p-4 shadow-[0_4px_12px_0_hsl(var(--background)/0.2)] sm:gap-8 sm:p-8 lg:p-12'>
			<div className='pointer-events-none absolute -right-20 -top-24 h-[420px] w-[420px] rounded-full opacity-60 blur-[110px]' style={{ background: 'hsl(var(--info))' }} />

			<img src={image} alt='' className={cn('pointer-events-none absolute right-0 right-[-20%] top-0 top-[10%] z-0 hidden h-full object-contain sm:block', imageClassName)} />

			<div className='relative z-10 flex flex-col gap-4'>
				<h2 className='max-w-[420px] text-2xl font-extrabold leading-[136%] tracking-[-0.16px] sm:text-[32px]'>{heading}</h2>
				<p className='max-w-[288px] text-base leading-[140%] tracking-[-0.24px] text-muted-foreground'>{description}</p>
			</div>

			<Button variant='secondary' className='w-fit'>
				View Details
			</Button>
		</div>
	)
}
